"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactHookForm = require("react-hook-form");

var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider"));

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _StaticDatePicker = _interopRequireDefault(require("@mui/lab/StaticDatePicker"));

var _ui = require("@alycecom/ui");

var _yup = require("@hookform/resolvers/yup");

var yup = _interopRequireWildcard(require("yup"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _ramda = require("ramda");

var _reactRedux = require("react-redux");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _timezones = require("../../../Shared/store/timezones");

var _timezones2 = require("../../../Shared/store/timezones/timezones.helpers");

var _Timezones$CONSTANTS = _timezones.Timezones.CONSTANTS,
    DEFAULT_TIMEZONE_NAME = _Timezones$CONSTANTS.DEFAULT_TIMEZONE_NAME,
    DEFAULT_TIMEZONE_TITLE = _Timezones$CONSTANTS.DEFAULT_TIMEZONE_TITLE;
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    submitButton: {
      padding: spacing(5 / 8, 12 / 8)
    },
    timezonesPopper: {
      minWidth: 300,
      left: '-50px !important'
    }
  };
});

var CustomScheduleForm = function CustomScheduleForm(_ref2) {
  var onSubmit = _ref2.onSubmit,
      onClose = _ref2.onClose;
  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tzSearch = _useState2[0],
      setTzSearch = _useState2[1];

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      _useGiftContext$user$ = _useGiftContext.user.timezone,
      userTimezone = _useGiftContext$user$ === void 0 ? '' : _useGiftContext$user$;

  var timezones = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezones);
  var timezoneNames = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezoneNames);
  var timezonesTitles = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezoneTitles);
  var defaultTimezone = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getDefaultTimezone);
  var timezoneTitle = (0, _react.useMemo)(function () {
    var timezoneName = timezoneNames.includes(userTimezone) ? userTimezone : defaultTimezone;
    var timezone = timezones.find(function (tz) {
      return tz.name === timezoneName;
    }) || {
      name: DEFAULT_TIMEZONE_NAME,
      title: DEFAULT_TIMEZONE_TITLE
    };
    return (0, _timezones2.formatTimezoneTitle)(timezone);
  }, [timezoneNames, timezones, defaultTimezone, userTimezone]);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    resolver: (0, _yup.yupResolver)(yup.object().shape({
      tz: yup.string().nullable().label('Timezone').trim().required(),
      hh: yup.number().label('Hours').required(),
      interval: yup.string().label('Period').required()
    })),
    defaultValues: {
      tz: timezoneTitle,
      hh: undefined,
      mm: undefined,
      interval: undefined,
      date: undefined
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isValid = _useForm$formState.isValid,
      watch = _useForm.watch,
      setValue = _useForm.setValue;

  var _watch = watch(['tz', 'interval', 'date', 'hh']),
      _watch2 = (0, _slicedToArray2.default)(_watch, 4),
      watchTz = _watch2[0],
      watchInterval = _watch2[1],
      watchDate = _watch2[2],
      watchHours = _watch2[3];

  var _useMemo = (0, _react.useMemo)(function () {
    var tzTitle = watchTz || timezoneTitle;
    var timezone = timezones.find(function (tz) {
      return tz.title === tzTitle;
    });
    var tz = (timezone === null || timezone === void 0 ? void 0 : timezone.name) || DEFAULT_TIMEZONE_NAME;
    var currentTimePlusHour = (0, _momentTimezone.default)().tz(tz).add(1, 'hours');

    var _currentTimePlusHour$ = currentTimePlusHour.format('h a').split(' '),
        _currentTimePlusHour$2 = (0, _slicedToArray2.default)(_currentTimePlusHour$, 2),
        nextHour = _currentTimePlusHour$2[0],
        meridien = _currentTimePlusHour$2[1];

    return {
      minDate: currentTimePlusHour,
      endOfTheDay: (0, _momentTimezone.default)().tz(tz).set({
        hours: 23,
        minutes: 59
      }),
      todayAmHours: meridien === 'am' ? (0, _ramda.range)(Number(nextHour), 12) : [],
      todayPmHours: meridien === 'am' ? (0, _ramda.range)(1, 13) : (0, _ramda.range)(Number(nextHour), 13)
    };
  }, [watchTz, timezones, timezoneTitle]),
      minDate = _useMemo.minDate,
      endOfTheDay = _useMemo.endOfTheDay,
      todayAmHours = _useMemo.todayAmHours,
      todayPmHours = _useMemo.todayPmHours;

  var isToday = (0, _momentTimezone.default)(watchDate).isSameOrBefore(endOfTheDay);
  var todayHours = watchInterval === 'am' ? todayAmHours : todayPmHours;
  var hours = isToday ? todayHours : (0, _ramda.range)(1, 13);
  var isChosenWrongInterval = isToday && watchInterval === 'am' && todayAmHours.length === 0;
  var isChosenWrongHours = isToday && !todayHours.includes(watchHours);
  (0, _react.useEffect)(function () {
    if (isChosenWrongInterval) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setValue('interval', undefined, {
        shouldValidate: true
      });
    }
  }, [isChosenWrongInterval, setValue]);
  (0, _react.useEffect)(function () {
    if (isChosenWrongHours) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setValue('hh', undefined, {
        shouldValidate: true
      });
    }
  }, [isChosenWrongHours, setValue]);
  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.default, {
    dateAdapter: _AdapterMoment.default
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "form",
    p: 3,
    display: "flex",
    flexDirection: "column",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Pick Date & Time"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "date",
    control: control,
    render: function render(_ref3) {
      var _ref3$field = _ref3.field,
          value = _ref3$field.value,
          onChange = _ref3$field.onChange;
      return /*#__PURE__*/_react.default.createElement(_StaticDatePicker.default, {
        displayStaticWrapperAs: "desktop",
        onChange: onChange,
        minDate: minDate,
        openTo: "day",
        disablePast: true,
        value: value,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react.default.createElement(_material.TextField, params);
        }
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 2.33 / 12,
    mr: 0.5
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "hh",
    control: control,
    render: function render(_ref4) {
      var _errors$hh, _errors$hh2;

      var _ref4$field = _ref4.field,
          onChange = _ref4$field.onChange,
          value = _ref4$field.value;
      return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
        error: !!((_errors$hh = errors.hh) !== null && _errors$hh !== void 0 && _errors$hh.message),
        variant: "outlined",
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "SendGift.CustomSchedule.HoursLabel"
      }, "Hours"), /*#__PURE__*/_react.default.createElement(_material.Select, {
        labelId: "SendGift.CustomSchedule.HoursLabel",
        label: "Hours",
        onChange: onChange,
        value: value,
        name: "hh"
      }, hours.map(function (hh) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: hh,
          value: hh
        }, String(hh).padStart(2, '0'));
      })), !!((_errors$hh2 = errors.hh) !== null && _errors$hh2 !== void 0 && _errors$hh2.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, errors.hh.message));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 2.33 / 12,
    mx: 0.5
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "mm",
    control: control,
    render: function render(_ref5) {
      var _ref5$field = _ref5.field,
          onChange = _ref5$field.onChange,
          value = _ref5$field.value;
      return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
        variant: "outlined",
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "SendGift.CustomSchedule.MinutesLabel"
      }, "Minutes"), /*#__PURE__*/_react.default.createElement(_material.Select, {
        labelId: "SendGift.CustomSchedule.MinutesLabel",
        label: "Minutes",
        onChange: onChange,
        value: value,
        name: "mm"
      }, Array.from({
        length: 4
      }, function (_, index) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: index,
          value: index * 15
        }, String(index * 15).padStart(2, '0'));
      })));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 2.33 / 12,
    mx: 0.5
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "interval",
    control: control,
    render: function render(_ref6) {
      var _errors$interval, _errors$interval2;

      var _ref6$field = _ref6.field,
          onChange = _ref6$field.onChange,
          value = _ref6$field.value;
      return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
        error: !!((_errors$interval = errors.interval) !== null && _errors$interval !== void 0 && _errors$interval.message),
        variant: "outlined",
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "SendGift.CustomSchedule.PeriodLabel"
      }, "Period"), /*#__PURE__*/_react.default.createElement(_material.Select, {
        labelId: "SendGift.CustomSchedule.PeriodLabel",
        label: "Period",
        onChange: onChange,
        value: value,
        name: "interval"
      }, !(isToday && todayAmHours.length === 0) && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        value: "am"
      }, "AM"), /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        value: "pm"
      }, "PM")), !!((_errors$interval2 = errors.interval) !== null && _errors$interval2 !== void 0 && _errors$interval2.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, errors.interval.message));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 5 / 12,
    ml: 0.5
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "tz",
    control: control,
    render: function render(_ref7) {
      var _errors$tz, _errors$tz2;

      var _ref7$field = _ref7.field,
          _onChange = _ref7$field.onChange,
          value = _ref7$field.value;
      return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
        error: !!((_errors$tz = errors.tz) !== null && _errors$tz !== void 0 && _errors$tz.message)
      }, /*#__PURE__*/_react.default.createElement(_ui.Autocomplete, {
        classes: {
          popper: classes.timezonesPopper
        },
        value: value,
        options: timezonesTitles,
        inputValue: tzSearch,
        label: "Your timezone",
        clearOnBlur: true,
        getOptionLabel: function getOptionLabel(option) {
          return option;
        },
        onChange: function onChange(_, v) {
          return _onChange(v);
        },
        onInputChange: function onInputChange(_, newValue) {
          return setTzSearch(newValue);
        }
      }), !!((_errors$tz2 = errors.tz) !== null && _errors$tz2 !== void 0 && _errors$tz2.message) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, errors.tz.message));
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "outlined",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    overrideClass: classes.submitButton,
    disabled: !isValid,
    width: "auto",
    type: "submit"
  }, "Confirm & Schedule Invite")))));
};

var _default = /*#__PURE__*/(0, _react.memo)(CustomScheduleForm);

exports.default = _default;